<template lang="pug">
    section#candidatar
        .wrapper
            h2 Veja como se candidatar
            ul
                li
                    img(:src="require('@images/icones/Bolsas/1.png')").icon
                    p
                        img(:src="require('@images/icones/Bolsas/1.png')")
                        |Você pode solicitar sua inscrição diretamente em um polo UniFAEL ou se inscrever aqui. Ao
                        |realizar a inscrição no vestibular, o estudante já está apto a participar e concorrer
                        |como inscrito no programa de bolsas.
                li
                    img(:src="require('@images/icones/Bolsas/2.png')").icon
                    p
                        img(:src="require('@images/icones/Bolsas/2.png')")
                        |O candidato deverá escolher o polo e o curso no qual deseja se inscrever
                        |e agendar a prova de vestibular, comparecendo no
                        |Polo escolhido na data agendada para participação do processo seletivo.
                li
                    img(:src="require('@images/icones/Bolsas/3.png')").icon
                    p
                        img(:src="require('@images/icones/Bolsas/3.png')")
                        |Após o resultado do vestibular, o candidato aprovado deverá comparecer novamente ao polo
                        |de inscrição, de acordo com o prazo limite informado pelo polo, para apresentação dos documentos e entrevista para
                        |classificação no programa de bolsas, que serão distribuídas de acordo com a disponibilidade do polo e
                        |classificação do aluno no processo.
                li
                    img(:src="require('@images/icones/Bolsas/4.png')").icon
                    p
                        img(:src="require('@images/icones/Bolsas/4.png')")
                        |Os candidatos serão contemplados de acordo com o número de bolsas disponíveis no polo. Se
                        |não houver mais bolsas disponíveis no Polo de inscrição escolhido, os candidatos poderão
                        |realizar matrícula normalmente nos cursos UniFAEL, pagando o valor integral das mensalidades.
            p Consulte seu polo e saiba mais!
            //- a(href="http://profael.com.br", target="_blank") visite o site do profael
</template>

<script>
export default {
    name: "section-candidatar"
}
</script>

<style lang="stylus" scoped src="./Candidatar.styl"></style>
